// import React, { useEffect, useMemo, useState } from "react";
// import "./WalletAllocationPopup.css";

// const API_BASE_URL =
//   process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";

// const money = (value) =>
//   new Intl.NumberFormat("en-IN", {
//     style: "currency",
//     currency: "INR",
//     minimumFractionDigits: 2,
//     maximumFractionDigits: 2,
//   }).format(Number(value ?? 0) || 0);

// const getTransactionType = (transaction) =>
//   String(
//     transaction?.type ??
//       transaction?.transaction_type ??
//       transaction?.transactionType ??
//       ""
//   )
//     .trim()
//     .toLowerCase();

// const formatWithdrawalId = (id) =>
//   String(id ?? "-").startsWith("WD-") ? String(id) : `WD-${id}`;

// const statusLabel = (status) =>
//   String(status || "UNKNOWN")
//     .replaceAll("_", " ")
//     .toLowerCase()
//     .replace(/\b\w/g, (letter) => letter.toUpperCase());

// function getWalletDetails(walletId, walletRows) {
//   const match = walletRows.find(
//     (item) =>
//       String(item?.wallet_id ?? item?.walletId ?? item?.id) ===
//       String(walletId)
//   );

//   return {
//     label:
//       match?.job_name ??
//       match?.jobName ??
//       match?.job_title ??
//       match?.jobTitle ??
//       match?.service_name ??
//       match?.serviceName ??
//       "Wallet credit",
//     publicWalletId:
//       match?.wallet_code ?? match?.walletCode ?? match?.reference ?? null,
//   };
// }

// export default function WalletAllocationPopup({
//   transaction,
//   walletRows = [],
// }) {
//   const [open, setOpen] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [preview, setPreview] = useState(null);

//   const isWithdrawal = getTransactionType(transaction) === "withdrawal";

//   const transactionId =
//     transaction?.wallet_id ??
//     transaction?.walletId ??
//     transaction?.id;

//   useEffect(() => {
//     if (!open) return;

//     const handleKeyDown = (event) => {
//       if (event.key === "Escape") setOpen(false);
//     };

//     window.addEventListener("keydown", handleKeyDown);
//     return () => window.removeEventListener("keydown", handleKeyDown);
//   }, [open]);

//   const openPreview = async () => {
//     if (!isWithdrawal || transactionId == null) return;

//     setOpen(true);
//     setLoading(true);
//     setError("");
//     setPreview(null);

//     try {
//       const jwt = localStorage.getItem("jwt");

//       const response = await fetch(
//         `${API_BASE_URL}/api/wallet-withdrawals/${encodeURIComponent(
//           transactionId
//         )}/allocation-preview`,
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             ...(jwt ? { Authorization: `Bearer ${jwt}` } : {}),
//           },
//         }
//       );

//       const body = await response.json().catch(() => ({}));

//       if (!response.ok) {
//         throw new Error(
//           body?.detail ||
//             body?.message ||
//             `Request failed (${response.status})`
//         );
//       }

//       const result = body?.data ?? body;

//       if (!Array.isArray(result?.allocations)) {
//         throw new Error(
//           "The allocation-preview API returned an unexpected response."
//         );
//       }

//       setPreview(result);
//     } catch (err) {
//       setError(err?.message || "Unable to load the allocation preview.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const usedWallets = useMemo(() => {
//     return (preview?.allocations ?? [])
//       .filter((item) => Number(item?.deducted_amount ?? 0) > 0)
//       .map((item) => ({
//         ...item,
//         ...getWalletDetails(item.wallet_id, walletRows),
//         state: String(item.status || "").toUpperCase(),
//       }));
//   }, [preview, walletRows]);

//   // Do not show a button for wallet credits or other transaction types.
//   if (!isWithdrawal) return null;

//   const withdrawalId = preview?.withdrawal_id ?? transactionId;

//   const amount =
//     preview?.withdrawal_amount ??
//     transaction?.wallet_amount_payable ??
//     transaction?.walletAmountPayable ??
//     transaction?.withdrawal_request_amount ??
//     transaction?.withdrawalRequestAmount ??
//     0;

//   return (
//     <>
//       <button
//         type="button"
//         className="wap-trigger"
//         onClick={openPreview}
//         title="View wallet allocation flow"
//       >
//         {transactionId}
//       </button>

//       {open && (
//         <div
//           className="wap-backdrop"
//           onMouseDown={(event) => {
//             if (event.target === event.currentTarget) setOpen(false);
//           }}
//         >
//           <section
//             className="wap-modal"
//             role="dialog"
//             aria-modal="true"
//             aria-labelledby="wap-title"
//           >
//             <button
//               type="button"
//               className="wap-close-icon"
//               aria-label="Close popup"
//               onClick={() => setOpen(false)}
//             >
//               ×
//             </button>

//             <header className="wap-header">
//               <h2 id="wap-title">Withdrawal Details</h2>

//               <div className="wap-subtitle-row">
//                 <span>
//                   Withdrawal ID: <strong>{formatWithdrawalId(withdrawalId)}</strong>
//                 </span>

//                 <span className="wap-status">
//                   {statusLabel(
//                     preview?.allocation_status ??
//                       transaction?.status ??
//                       "In Progress"
//                   )}
//                 </span>
//               </div>
//             </header>

//             {loading ? (
//               <div className="wap-state">
//                 <span className="wap-spinner" />
//                 Loading wallet allocation...
//               </div>
//             ) : error ? (
//               <div className="wap-error">
//                 <strong>Could not load allocation</strong>
//                 <span>{error}</span>
//                 <button type="button" onClick={openPreview}>
//                   Try again
//                 </button>
//               </div>
//             ) : preview ? (
//               <>
//                 <div className="wap-summary">
//                   <div className="wap-withdrawal-node">
//                     <span className="wap-node-caption">Withdrawal</span>
//                     <strong>{formatWithdrawalId(withdrawalId)}</strong>
//                     <b>{money(amount)}</b>
//                   </div>

//                   <div className="wap-flow-list">
//                     {usedWallets.length === 0 ? (
//                       <div className="wap-empty">
//                         No wallet allocations were found for this withdrawal.
//                       </div>
//                     ) : (
//                       usedWallets.map((wallet, index) => {
//                         const fullyUsed =
//                           wallet.state === "FULLY_USED" ||
//                           Number(wallet.remaining_balance ?? 0) === 0;

//                         const walletDisplayId = wallet.wallet_id;

//                         return (
//                           <div
//                             className={`wap-flow-row ${
//                               fullyUsed ? "wap-full" : "wap-partial"
//                             }`}
//                             key={wallet.wallet_id}
//                           >
//                             <div className="wap-connector">
//                               <span className="wap-amount-label">
//                                 {money(wallet.deducted_amount)}
//                               </span>

//                               <svg
//                                 viewBox="0 0 100 34"
//                                 preserveAspectRatio="none"
//                                 aria-hidden="true"
//                               >
//                                 <path d="M 0 17 C 35 17, 45 17, 83 17" />
//                                 <path
//                                   className="wap-arrow-head"
//                                   d="M 76 8 L 88 17 L 76 26"
//                                 />
//                               </svg>
//                             </div>

//                             <article className="wap-wallet-card">
//                               <div className="wap-wallet-avatar">
//                                 W{index + 1}
//                               </div>

                                 
//                                 <div className="wap-wallet-info">
//                                   <strong className="wap-wallet-id">
//                                     Wallet ID: {walletDisplayId}
//                                   </strong>

//                                   <span
//                                     className="wap-wallet-job"
//                                     title={wallet.label}
//                                   >
//                                     {wallet.label}
//                                   </span>

//                                   <span className="wap-wallet-total">
//                                     Total: {money(wallet.original_amount)}
//                                   </span>
//                                 </div>

//                               <div
//                                 className={`wap-remaining ${
//                                   fullyUsed ? "is-zero" : "is-partial"
//                                 }`}
//                               >
//                                 <span>Remaining</span>
//                                 <strong>
//                                   {money(wallet.remaining_balance)}
//                                 </strong>
//                               </div>
//                             </article>
//                           </div>
//                         );
//                       })
//                     )}
//                   </div>
//                 </div>

//                 <footer className="wap-legend">
//                   <div className="wap-legend-item">
//                     <span className="wap-legend-line full" />
//                     <div>
//                       <strong>Full amount used</strong>
//                       <small>Wallet completely consumed</small>
//                     </div>
//                   </div>

//                   <div className="wap-legend-item">
//                     <span className="wap-legend-line partial" />
//                     <div>
//                       <strong>Partially used</strong>
//                       <small>Some amount used, balance remains</small>
//                     </div>
//                   </div>
//                 </footer>

//                 {Number(preview.unallocated_amount ?? 0) > 0 && (
//                   <div className="wap-unallocated">
//                     Unallocated amount:{" "}
//                     <strong>{money(preview.unallocated_amount)}</strong>
//                   </div>
//                 )}

//                 {preview.warning && (
//                   <p className="wap-warning">
//                     This preview is reconstructed from transaction history,
//                     not a persisted allocation ledger.
//                   </p>
//                 )}
//               </>
//             ) : null}

//             <div className="wap-footer">
//               <button
//                 type="button"
//                 className="wap-close-button"
//                 onClick={() => setOpen(false)}
//               >
//                 Close
//               </button>
//             </div>
//           </section>
//         </div>
//       )}
//     </>
//   );
// }

import React, { useEffect, useMemo, useState } from "react";
import "./WalletAllocationPopup.css";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";

const money = (value) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(value ?? 0) || 0);

const getTransactionType = (transaction) =>
  String(
    transaction?.type ??
      transaction?.transaction_type ??
      transaction?.transactionType ??
      ""
  )
    .trim()
    .toLowerCase();

const formatWithdrawalId = (id) =>
  String(id ?? "-").startsWith("WD-") ? String(id) : `WD-${id}`;

const statusLabel = (status) =>
  String(status || "UNKNOWN")
    .replaceAll("_", " ")
    .toLowerCase()
    .replace(/\b\w/g, (letter) => letter.toUpperCase());

function getWalletDetails(walletId, walletRows) {
  const match = walletRows.find(
    (item) =>
      String(item?.wallet_id ?? item?.walletId ?? item?.id) ===
      String(walletId)
  );

  return {
    label:
      match?.job_name ??
      match?.jobName ??
      match?.job_title ??
      match?.jobTitle ??
      match?.service_name ??
      match?.serviceName ??
      "Wallet credit",
    publicWalletId:
      match?.wallet_code ?? match?.walletCode ?? match?.reference ?? null,
  };
}


const getWithdrawalRowId = (row) => {
  if (getTransactionType(row) !== "withdrawal") {
    return null;
  }

  return (
    row?.wallet_id ??
    row?.walletId ??
    row?.withdrawal_id ??
    row?.withdrawalId ??
    null
  );
};


const normalizeWithdrawalId = (id) =>
  String(id ?? "").replace(/^WD-/i, "").trim();

const getWithdrawalOwnerId = (row) => {
  // Prefer a real user ID, but ignore placeholder values from normalization.
  const userId = row?.user_id ?? row?.userId;
  const ownerId = row?.owner_id ?? row?.ownerId;
  const candidate =
    userId != null && String(userId).trim() !== "" && String(userId) !== "-"
      ? userId
      : ownerId;

  if (candidate == null) return null;

  // Some rows store a composite key like "user[52051]-withdrawal-1760".
  const compositeMatch = String(candidate).match(/user\[(\d+)\]/i);
  return compositeMatch ? compositeMatch[1] : candidate;
};

const getWithdrawalDate = (row) =>
  row?.withdrawal_date ??
  row?.withdrawalDate ??
  row?.created_at ??
  row?.createdAt ??
  "";

export default function WalletAllocationPopup({
  transaction,
  walletRows = [],
  withdrawalRows = [],
}) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [preview, setPreview] = useState(null);
  const [selectedWithdrawalId, setSelectedWithdrawalId] = useState(null);

  const isWithdrawal = getTransactionType(transaction) === "withdrawal";

  
  const transactionId =
    transaction?.wallet_id ??
    transaction?.walletId ??
    transaction?.withdrawal_id ??
    transaction?.withdrawalId ??
    transaction?.id;



  useEffect(() => {
    if (!open) return;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") setOpen(false);
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [open]);

  const openPreview = async (requestedWithdrawalId = transactionId) => {
    if (!isWithdrawal || requestedWithdrawalId == null) return;

    setSelectedWithdrawalId(requestedWithdrawalId);
    setOpen(true);
    setLoading(true);
    setError("");
    setPreview(null);

    try {
      const jwt = localStorage.getItem("jwt");

      const response = await fetch(
        `${API_BASE_URL}/api/wallet-withdrawals/${encodeURIComponent(
          requestedWithdrawalId
        )}/allocation-preview`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            ...(jwt ? { Authorization: `Bearer ${jwt}` } : {}),
          },
        }
      );

      const body = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(
          body?.detail ||
            body?.message ||
            `Request failed (${response.status})`
        );
      }

      const result = body?.data ?? body;

      if (!Array.isArray(result?.allocations)) {
        throw new Error(
          "The allocation-preview API returned an unexpected response."
        );
      }

      setPreview(result);
    } catch (err) {
      setError(err?.message || "Unable to load the allocation preview.");
    } finally {
      setLoading(false);
    }
  };

  
  const currentWithdrawalId =
    selectedWithdrawalId ??
    preview?.withdrawal_id ??
    transactionId;


  const currentOwnerId =
    preview?.owner_id ??
    getWithdrawalOwnerId(transaction);

  const sameUserWithdrawals = useMemo(() => {
    if (currentOwnerId == null) return [];

    // The list endpoint can contain repeated rows for a withdrawal.
    // Keep one entry per withdrawal ID, and compare by the real user ID.
    const unique = new Map();

    withdrawalRows.forEach((row) => {
      const rowOwnerId = getWithdrawalOwnerId(row);
      const rowWithdrawalId = getWithdrawalRowId(row);

      if (
        rowOwnerId == null ||
        rowWithdrawalId == null ||
        String(rowOwnerId).trim() !== String(currentOwnerId).trim()
      ) {
        return;
      }

      const key = normalizeWithdrawalId(rowWithdrawalId);
      if (!unique.has(key)) unique.set(key, row);
    });

    return Array.from(unique.values()).sort((a, b) => {
      const dateA = new Date(getWithdrawalDate(a)).getTime() || 0;
      const dateB = new Date(getWithdrawalDate(b)).getTime() || 0;

      if (dateA !== dateB) return dateA - dateB;

      return (
        Number(getWithdrawalRowId(a)) -
        Number(getWithdrawalRowId(b))
      );
    });
  }, [withdrawalRows, currentOwnerId]);

  const currentWithdrawalIndex = sameUserWithdrawals.findIndex(
  (row) =>
    normalizeWithdrawalId(getWithdrawalRowId(row)) ===
    normalizeWithdrawalId(currentWithdrawalId)
);

  const previousWithdrawal =
    currentWithdrawalIndex > 0
      ? sameUserWithdrawals[currentWithdrawalIndex - 1]
      : null;

  const nextWithdrawal =
    currentWithdrawalIndex >= 0 &&
    currentWithdrawalIndex < sameUserWithdrawals.length - 1
      ? sameUserWithdrawals[currentWithdrawalIndex + 1]
      : null;
  console.log("Withdrawal navigation debug:", {
  transactionId,
  currentWithdrawalId,
  currentOwnerId,
  totalWithdrawalsReceived: withdrawalRows.length,
  sameUserWithdrawals: sameUserWithdrawals.map((row) => ({
    id: getWithdrawalRowId(row),
    ownerId: getWithdrawalOwnerId(row),
    date: getWithdrawalDate(row),
  })),
  currentWithdrawalIndex,
  previousWithdrawalId: getWithdrawalRowId(previousWithdrawal),
  nextWithdrawalId: getWithdrawalRowId(nextWithdrawal),
});
  const usedWallets = useMemo(() => {
    return (preview?.allocations ?? [])
      .filter((item) => Number(item?.deducted_amount ?? 0) > 0)
      .map((item) => ({
        ...item,
        ...getWalletDetails(item.wallet_id, walletRows),
        state: String(item.status || "").toUpperCase(),
      }));
  }, [preview, walletRows]);

  // Do not show a button for wallet credits or other transaction types.
  if (!isWithdrawal) return null;

  const withdrawalId = preview?.withdrawal_id ?? transactionId;

  const amount =
    preview?.withdrawal_amount ??
    transaction?.wallet_amount_payable ??
    transaction?.walletAmountPayable ??
    transaction?.withdrawal_request_amount ??
    transaction?.withdrawalRequestAmount ??
    0;

  return (
    <>
      <button
        type="button"
        className="wap-trigger"
        onClick={() => openPreview(transactionId)}
        title="View wallet allocation flow"
      >
        {transactionId}
      </button>

      {open && (
        <div
          className="wap-backdrop"
          onMouseDown={(event) => {
            if (event.target === event.currentTarget) setOpen(false);
          }}
        >
          <section
            className="wap-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="wap-title"
          >
            <button
              type="button"
              className="wap-close-icon"
              aria-label="Close popup"
              onClick={() => setOpen(false)}
            >
              ×
            </button>

            <header className="wap-header">
              <h2 id="wap-title">Withdrawal Details</h2>

              <div className="wap-subtitle-row">
                <span>
                  Withdrawal ID: <strong>{formatWithdrawalId(withdrawalId)}</strong>
                </span>

                <span className="wap-status">
                  {statusLabel(
                    preview?.allocation_status ??
                      transaction?.status ??
                      "In Progress"
                  )}
                </span>
              </div>

              <div className="wap-withdrawal-navigation">
                <button
                  type="button"
                  disabled={!previousWithdrawal || loading}
                  onClick={() =>
                    openPreview(getWithdrawalRowId(previousWithdrawal))
                  }
                >
                  ↑ Previous Withdrawal
                </button>

                <span>
                  {currentWithdrawalIndex >= 0
                    ? `${currentWithdrawalIndex + 1} of ${sameUserWithdrawals.length}`
                    : "Withdrawal"}
                </span>
              </div>
            </header>

            {loading ? (
              <div className="wap-state">
                <span className="wap-spinner" />
                Loading wallet allocation...
              </div>
            ) : error ? (
              <div className="wap-error">
                <strong>Could not load allocation</strong>
                <span>{error}</span>
                <button type="button" onClick={() => openPreview(withdrawalId)}>
                  Try again
                </button>
              </div>
            ) : preview ? (
              <>
                <div className="wap-summary">
                  <div className="wap-withdrawal-node">
                    <span className="wap-node-caption">Withdrawal</span>
                    <strong>{formatWithdrawalId(withdrawalId)}</strong>
                    <b>{money(amount)}</b>
                  </div>

                  <div className="wap-flow-list">
                    {usedWallets.length === 0 ? (
                      <div className="wap-empty">
                        No wallet allocations were found for this withdrawal.
                      </div>
                    ) : (
                      usedWallets.map((wallet, index) => {
                        const fullyUsed =
                          wallet.state === "FULLY_USED" ||
                          Number(wallet.remaining_balance ?? 0) === 0;

                        const walletDisplayId = wallet.wallet_id;

                        return (
                          <div
                            className={`wap-flow-row ${
                              fullyUsed ? "wap-full" : "wap-partial"
                            }`}
                            key={wallet.wallet_id}
                          >
                            
                          <div className="wap-connector">
                            <svg
                              className="wap-connector-arrow"
                              viewBox="0 0 100 34"
                              preserveAspectRatio="none"
                              aria-hidden="true"
                            >
                              <path d="M 0 17 C 35 17, 45 17, 83 17" />
                              <path
                                className="wap-arrow-head"
                                d="M 76 8 L 88 17 L 76 26"
                              />
                            </svg>

                            <span className="wap-amount-label">
                              {money(wallet.deducted_amount)}
                            </span>
                          </div>

                            <article className="wap-wallet-card">
                              <div className="wap-wallet-avatar">
                                W{index + 1}
                              </div>

                                                            
                                <div className="wap-wallet-info">
                                  <div className="wap-wallet-title-row">
                                    <strong className="wap-wallet-id">
                                      Wallet ID: {walletDisplayId}
                                    </strong>

                                    <span
                                      className="wap-wallet-job"
                                      title={wallet.label}
                                    >
                                      {wallet.label}
                                    </span>

                                    <span className="wap-wallet-total">
                                      Total: {money(wallet.original_amount)}
                                    </span>
                                  </div>
                                </div>


                              <div
                                className={`wap-remaining ${
                                  fullyUsed ? "is-zero" : "is-partial"
                                }`}
                              >
                                <span>Remaining</span>
                                <strong>
                                  {money(wallet.remaining_balance)}
                                </strong>
                              </div>
                            </article>
                          </div>
                        );
                      })
                    )}
                  </div>
                </div>

                <footer className="wap-legend">
                  <div className="wap-legend-item">
                    <span className="wap-legend-line full" />
                    <div>
                      <strong>Full amount used</strong>
                      <small>Wallet completely consumed</small>
                    </div>
                  </div>

                  <div className="wap-legend-item">
                    <span className="wap-legend-line partial" />
                    <div>
                      <strong>Partially used</strong>
                      <small>Some amount used, balance remains</small>
                    </div>
                  </div>
                </footer>

                {Number(preview.unallocated_amount ?? 0) > 0 && (
                  <div className="wap-unallocated">
                    Unallocated amount:{" "}
                    <strong>{money(preview.unallocated_amount)}</strong>
                  </div>
                )}

                {preview.warning && (
                  <p className="wap-warning">
                    This preview is reconstructed from transaction history,
                    not a persisted allocation ledger.
                  </p>
                )}
              </>
            ) : null}
           
              <div className="wap-footer">
                <button
                  type="button"
                  className="wap-next-button"
                  disabled={!nextWithdrawal || loading}
                  onClick={() =>
                    openPreview(getWithdrawalRowId(nextWithdrawal))
                  }
                >
                  Next Withdrawal ↓
                </button>

                <button
                  type="button"
                  className="wap-close-button"
                  onClick={() => setOpen(false)}
                >
                  Close
                </button>
              </div>

          </section>
        </div>
      )}
    </>
  );
}